import { Textarea } from "@/components/ui/textarea"
import { ValidationError } from "../form/ValidationError"

interface SituationProps {
  formData: {
    description: string
  }
  handleInputChange: (field: string, value: string) => void
  showErrors: boolean
}

export function SituationStep({ formData, handleInputChange, showErrors }: SituationProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-1 text-[#18375d]">
          Describe the Situation and Desired Outcome <span className="text-[#ea384c]">*</span>
        </label>
        <Textarea
          value={formData.description}
          onChange={(e) => handleInputChange("description", e.target.value)}
          placeholder="Please describe what's happening and what you want the recipient to do about it."
          className={`min-h-[200px] ${showErrors && !formData.description ? "border-[#ea384c]" : ""}`}
        />
        {showErrors && !formData.description && (
          <ValidationError message="Description cannot be blank" />
        )}
      </div>
    </div>
  )
}